// 渠道
export const channel = new Map([
  [
    'wechat',
    [{
        category: 'wechat',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat.png',
        title: '微信公众号支付',
        info: '应用于微信公众号/企业付款',
        type: 'JSGZHAPI',
        status: false,
      },
      {
        category: 'wechat',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat.png',
        title: '微信小程序支付',
        info: '应用于微信小程序付款',
        type: 'JSAPI',
        status: false,
      },
      {
        category: 'wechat',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat-app.png',
        title: '微信 APP 支付',
        info: '应用于APP/企业付款',
        type: 'APP',
        status: false,
      },
      // {
      //   category: 'wechat',
      //   icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
      //   typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat-mweb.png',
      //   title: '微信 H5 支付',
      //   info: '应用于微信公众号/企业付款',
      //   type: 'MWEB',
      //   status: false,
      // },
      // {
      //   category: 'wechat',
      //   icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
      //   typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat-ewm.png',
      //   title: '微信 NATIVE 支付',
      //   info: '应用于用户主扫付款',
      //   type: 'NATIVE',
      //   status: false,
      // },
      {
        category: 'wechat',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat-sm.png',
        title: '微信当面付',
        info: '应用于用户被扫付款',
        type: 'MICROPAY',
        status: false,
      },
      // {
      //   category: 'wechat',
      //   icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/weixin.png',
      //   typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/wechat.png',
      //   title: '转账到微信账户',
      //   info: '应用于微信转账付款',
      //   type: 'TRANSFER',
      //   status: false,
      // },
    ],
  ],
  [
    'alipay',
    [{
        category: 'alipay',
        kind: 'alipay',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifubao.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-app.png',
        title: '支付宝 App 支付',
        info: '应用于微信公众号/企业付款',
        type: 'APP',
        status: false,
      },
      // {
      //   category: 'alipay',
      //   icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifubao.png',
      //   typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-web.png',
      //   title: '支付宝电脑网站支付',
      //   info: '应用于PC/分期付款',
      //   type: 'PAGE',
      //   status: false,
      // },
      {
        category: 'alipay',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifubao.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-mweb.png',
        title: '支付宝手机网站支付',
        info: '应用于WAP/分期付款',
        type: 'WAP',
        status: false,
      },
      {
        category: 'alipay',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifubao.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-ewm.png',
        title: '支付宝当面付',
        info: '应用于扫码支付/分期付款',
        type: 'F2FPAY',
        status: false,
      },
      {
        category: 'alipay',
        icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifubao.png',
        typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-web.png',
        title: '企业转账到支付宝账户',
        info: '应用于支付宝转账付款',
        type: 'TRANSFER',
        status: false,
      },
    ],
  ],
  // [
  //   'unionpay',
  //   [
  //     {
  //       category: 'unionpay',
  //       icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/zhifupingtai-yinlian.png',
  //       typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/alipay-web.png',
  //       title: '银联二维码支付',
  //       info: '应用于微信公众号/企业付款',
  //       type: 'H5',
  //       status: false,
  //     },
  //   ],
  // ],
]);
export const heepayChannel = new Map([
  [
    'heepay',
    [{
      category: 'heepay',
      icon: 'https://cdn.chinachdu.com/webStatic/pay-platform/heepay.png',
      typeImage: 'https://cdn.chinachdu.com/webStatic/pay-platform/heepay-web.png',
      title: '汇付宝支付',
      info: '应用于使用汇付宝付款',
      type: 'HEEPAY',
      status: false,
    }, ],
  ],
]);
export const setUpList = new Map([
  [
    'wechat',
    [{
        label: 'AppId',
        prop: 'appId',
        type: 'text',
        placeholder: '请输入 AppID',
        info: '打开微信商户平台-产品中心-开发配置，填入APPID',
      },
      {
        label: '微信支付商户号',
        prop: 'mchAccount',
        type: 'text',
        placeholder: '请输入微信支付商户号',
        info: '微信支付申请完成之后，在微信商户平台的通知邮件中获取，请确保邮件上的 AppID 与微信开放平台上的 AppID 一致。',
      },
      {
        label: 'API 密钥',
        prop: 'mchPublicKey',
        type: 'text',
        placeholder: '请输入API 密钥',
        info: '打开微信商户平台-账户中心-账户设置-API安全-设置密钥，填入API密钥。',
      },
      {
        label: 'API 证书',
        prop: 'keyPath',
        type: 'upload',
        placeholder: '请输入API 证书',
        info: 'Pem 格式，用于退款及退款查询。打开微信商户平台 - 账户中心 - 账户设置 - API安全 - 下载API证书。',
      },
      {
        label: 'API 证书密钥',
        prop: 'appPrivateKey',
        type: 'textarea',
        placeholder: '请输入API 证书密钥',
        info: 'Pem 格式，用于退款及退款查询。打开微信商户平台 - 账户中心 - 账户设置 - API安全 - 下载API证书。',
      },
      {
        label: '三方商户简称',
        prop: 'mchName',
        type: 'text',
        placeholder: '请输入三方商户简称',
        info: '',
      },
      {
        label: '公众号密钥',
        prop: 'secret',
        type: 'textarea',
        placeholder: '请输入公众号密钥',
        info: '',
      },
    ],
  ],
  [
    'alipay',
    [{
        label: 'AppId',
        prop: 'appId',
        type: 'text',
        placeholder: '请输入 AppID',
        info: '打开支付宝开放平台 - 密钥管理 - 开放平台密钥 - APPID，签约并添加APP 支付功能的应用 ID',
      },
      {
        label: '合作伙伴身份',
        tip: '(PID)',
        prop: 'userId',
        type: 'text',
        placeholder: '请输入合作伙伴身份(PID)',
        info: '打开支付宝开放平台 - 账户管理 - 合作伙伴管理 - 角色身份 - PID',
      },
      {
        label: '支付宝公钥',
        prop: 'mchPublicKey',
        type: 'textarea',
        placeholder: '请输入支付宝公钥',
        info: 'RSA2：支付宝开放平台 - 密钥管理 - 开放平台密钥 - RSA(SHA256)密钥 - 查看支付宝公钥',
      },
      {
        label: '应用私钥',
        prop: 'appPrivateKey',
        type: 'textarea',
        placeholder: '请输入应用私钥',
        info: '（非 PKCS 编码）RSA2：与「支付宝开放平台 - 密钥管理 - 开放平台密钥 - RSA(SHA256)密钥」中设置的应用公钥对应的应用私钥',
      },
      {
        label: '三方商户简称',
        prop: 'mchName',
        type: 'text',
        placeholder: '请输入三方商户简称',
        info: '',
      },
      {
        label: '支付宝应用公钥证书',
        prop: 'certPath',
        type: 'upload1',
        placeholder: '请上传支付宝应用公钥证书',
        info: '',
        certPath: []
      },
      {
        label: '支付宝公钥证书',
        prop: 'alipayPublicCertPath',
        type: 'upload2',
        placeholder: '请上传支付宝公钥证书',
        info: '',
        alipayPublicCertPath: []
      },
      {
        label: '支付宝根证书',
        prop: 'rootCertPath',
        type: 'upload3',
        placeholder: '请上传支付宝根证书',
        info: '',
        rootCertPath: []
      },
    ],
  ],
  [
    'unionpay',
    [{
        label: '商户号',
        prop: 'appid',
        type: 'text',
        placeholder: '请输入商户号',
        info: '在银联二维码支付入网参数信息通知邮件中获取',
      },
      {
        label: '安全证书(pfx 格式)',
        prop: 'businessNum',
        type: 'upload',
        placeholder: '请输入微信支付商户号',
        info: '在 CFCA 数字证书下载平台下载并导出包含私钥的安全证书',
      },
      {
        label: '安全证书密码',
        prop: 'key',
        type: 'text',
        placeholder: '请输入安全证书密码',
        info: '导出安全证书时设置的证书密码',
      },
      {
        label: '敏感信息加密证书',
        tip: '(cer 格式)',
        prop: 'certificate',
        type: 'upload',
        placeholder: '请输入API 证书',
        info: '商户号开通了商户对敏感信息加密的权限',
      },
      {
        label: '验签中级证书',
        tip: '(cer 格式)',
        prop: 'certificateKey',
        type: 'upload',
        placeholder: '请输入API 证书密钥',
        info: '银联提供',
      },
      {
        label: '验签根证书',
        tip: '(cer 格式)',
        prop: 'certificateKey1',
        type: 'upload',
        placeholder: '请输入API 证书密钥',
        info: '银联提供',
      },
      {
        label: '三方商户简称',
        prop: 'mchName',
        type: 'text',
        placeholder: '请输入三方商户简称',
        info: '',
      },
    ],
  ],
  [
    'heepay',
    [{
        label: '汇付宝商户UID',
        prop: 'hyUid',
        type: 'text',
        placeholder: '请输入汇付宝商户UID',
        info: '登录汇付宝平台查看汇付宝的商户UID并输入',
      },
      {
        label: '汇付宝商户登录号',
        prop: 'hyLoginNumber',
        type: 'text',
        placeholder: '请输入汇付宝商户登录号',
        info: '与汇付宝商户登录号保持一致',
      },
      {
        label: '汇付宝应用appid',
        prop: 'hyApplyId',
        type: 'text',
        placeholder: '请输入汇付宝应用appid',
        info: '登录汇付宝查看所属应用的appid',
      },
      {
        label: '汇付宝应用密钥',
        prop: 'hyApplyKey',
        type: 'text',
        placeholder: '请输入汇付宝应用的MD5签名密钥',
        info: '登录汇付宝点击应用配置，选中应用，点击密钥，进入应用查看界面，填入MD5签名密钥',
      },
      {
        label: '微信小程序appid',
        prop: 'wxAppid',
        type: 'text',
        placeholder: '请输入微信小程序appid',
        info: '打开微信商户平台-产品中心-开发配置，填入APPID',
      },
      {
        label: '描述信息',
        prop: 'relationDescribe',
        type: 'text',
        placeholder: '请简单描述该支付信息',
        info: '请简单表述该应用信息',
        required: false,
      },
      {
        label: '三方商户简称',
        prop: 'mchName',
        type: 'text',
        placeholder: '请输入三方商户简称',
        info: '',
      },
    ],
  ],
]);

export const rulesdemo = {
  required: true,
  message: '请输入内容',
  trigger: 'blur'
};

// 审核开关
export const tableData = [{
    label: '对账渠道',
    width: 187,
    prop: 'qudao',
  },
  {
    label: '对账支付方式',
    width: 457,
    prop: 'qudao',
  },
  {
    label: '对账交易类型',
    width: 262,
    prop: 'qudao',
  },
  {
    label: '开关',
    prop: 'status',
  },
];